import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui';
import { Compass } from 'lucide-react';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="grid min-h-[60vh] place-items-center text-center">
      <div className="grid place-items-center gap-3">
        <Compass className="h-10 w-10 text-ink-faint" strokeWidth={1.5} />
        <div className="font-serif text-6xl font-medium text-ink-faint">404</div>
        <p className="text-ink-soft">Esta página no existe o fue movida.</p>
        <Button className="mt-1" onClick={() => navigate('/agente')}>
          Ir al inicio
        </Button>
      </div>
    </div>
  );
}
